import { isArrayField } from '@formily/core'
import { useField } from '@formily/react'

export const useArrayField = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let field = useField()

  while (!isArrayField(field)) {
    field = field.parent
  }

  return field
}
